<template>
  <div class="main">
    <ListView :on-infinite="onLoadMore" :hasMore="recordHasMore">
      <div class="list-item" v-for="item in recordList" :key="item.id">
          <div class="row main">
              <div class="right">{{item.point}}{{pointUnit}}</div>
              <div class="left">{{item.num}} 公共积分-{{item.phone}}</div>
          </div>
          <div class="row sub">
              <div class="right">{{item | chargeStatusText}}</div>
              <div class="left">{{item.time}}</div>
          </div>
      </div>
      <template slot="load-done">
        <Nothing></Nothing>
      </template>
    </ListView>
    <EmptyListTip
      v-if="recordReady && recordList.length <= 0"
      :icon="require('../../assets/icon-empty-cart.png')"
      text="无充值记录"
    />
  </div>
</template>

<script>

import api from '../../api'

export default {
  title: '文旅公共积分充值记录',
  bodyClass:'gray-bg',
  components: { },
  filters: {
    chargeStatusText(item){
      if(item.chargeStatus == 0){
        return '等待中'
      }
      if(item.chargeStatus == 1){
        return '交易中'
      }
      if(item.chargeStatus == 2){
        return '交易成功'
      }
      if(item.chargeStatus == 3){
        return '交易失败'
      }
      return `未知状态${item.chargeStatus}`
    }
  },
  data () {
    return {
        pointUnit: api.store.loginedUser.config.pointName,
        lastId: '',
        recordHasMore: true,
        recordReady: false,
        recordList: [
            // {
            //     id: 0,
            //     phone: '15017527670',
            //     num: 100,
            //     point: 1000,
            //     time: '2020-03-24 18:23:19'
            // }
        ]
    }
  },
  methods:{
    onLoadMore(done) {
      this.loadRecordList(false, done);
    },
    loadRecordList(isNew, doneCb) {
      if (!doneCb) {
        doneCb = () => {};
      }
      if (isNew) {
        this.recordReady = false;
        this.recordList = [];
        this.recordHasMore = true;
      }
      this.$showLoading("加载中...");

      api.jifentong.recordList(
        this.lastId,
        res => {
          res.records.forEach(e => {
            this.recordList.push({
                id: e.orderno,
                phone: e.phone,
                num: e.faceValue,
                point: e.pricePoint,
                time: e.createTime,
                chargeStatus: e.chargeStatus
            });
          });

          this.recordHasMore = res.hasMore;
          this.lastId = res.lastId;
          this.recordReady = true;

          doneCb();
          this.$hideLoading();
        },
        r => {
          this.$alertDialog(r.msg);
          this.$hideLoading();
          doneCb();
        }
      );
    }
  },
  mounted(){
    this.loadRecordList(true)
  }
}
</script>

<style scoped lang="less">

.list-item{
    border-bottom: 1px solid #ddd;
    padding: 2.67vw 4vw;
    background: #fff;
}

.row{
    margin-top: 1.33vw;

    &.main{
        color: #333333;
        font-size: 4vw;
    }

    &.sub{
        color: #999999;
        font-size: 3.47vw;
    }

    .right{
        float: right;
    }

}

</style>



// WEBPACK FOOTER //
// src/pages/wenhuajifen/Orders.vue